import request from "../libs/request";

export interface AreaItem {
  name?: string;
  code?: number;
  childGeoList?: AreaItem[];
}

/**
 * 查询各种协议
 * @param {{ type: number; language: string }} { 协议类型, 协议语言 }
 */
export function getAgreement({
  type = 1,
  language = "zh",
}: {
  type: number | string;
  language?: string;
}) {
  return request<{
    agreementId: string;
    agreementType: number;
    content: string;
    createTime: string;
    createUser: string;
    enableFlag: number;
    remark: string;
    version: string;
  }>({
    url: `/api/privacyAgmt?agmtType=${type}`,
    method: "get",
    headers: { language },
  });
}

/**
 * 获取省市区数据
 */
export function getAreaData() {
  return request<{
    provinceGeoList: AreaItem[];
  }>({
    url: "/api/app/dict/geo/getAllGeos",
  });
}

export interface ICouponGroupItem {
  groupAliasId: string;
  aliasName: string;
  count?: number;
  status?: number;
}
/**
 * 获取所有卡券分组信息
 */
export function getAllCardGroup() {
  return request<{ data: ICouponGroupItem[] }>({
    url: "/api/rights/findAllCardGroup",
    params: {
      userListReveal: 1,
    },
  });
}

/**
 * 获取所有卡券分组信息
 * 接口地址: http://appserver-view.dev.internal.avatr.com:9080/swagger-ui.html#/%E6%9D%83%E7%9B%8A%E4%B8%AD%E5%BF%83/queryMyCardUsingPOST
 */
export function getCouponListById(params: any) {
  return request<{
    result: any[];
    totalNum: number;
  }>({
    url: "/api/rights/queryMyCard",
    method: "post",
    data: params,
  });
}

/**
 * 激活卡券/权益
 */
export function activeRightsOrCards(params: any) {
  return request({
    url: "/api/rights/operateRightsAndCards",
    method: "post",
    data: params,
  });
}
/**
 * 卡券兑换E值
 * @param params 
 * @returns 
 */
export function exchangeCoupon2E(data: any) {
  return request({
    url: "/api/rights/toExchangePoint",
    method: "post",
    data,
  });
}

interface IAccountInfo {
  overCount: number;
  totalCount: number;
  cardValidStr: string;
  rightsAccountNo: string;
}

interface paginationParam {
  pageNo: number;
  pageSize: number;
}

/**
 * 获取卡券额度信息
 */
export function queryAccountInfo(params: { rightsAccountId: string }) {
  return request<IAccountInfo>({
    url: "/api/rights/getAccountInfoByAccountId",
    method: "GET",
    params,
  });
}

interface IUseRecord {
  pageNo: number;
  pageSize: number;
  totalNum: number;
  result: IUseRecordItem[];
}

export interface IUseRecordItem {
  operateDesc: string;
  rightsDetailId: string;
  relationInfo: string;
  operateNum: string;
  createTime: string;
  operateType: number;
}

/**
 * 获取卡券使用记录
 */
export function queryUseRecord(
  params: { rightsAccountId: string } & paginationParam
) {
  return request<IUseRecord>({
    url: "/api/rights/pageUseAccountDetails",
    method: "GET",
    params,
  });
}

/**
 * 默认固定手机号登录,仅测试环境使用
 */
export const phoneLogin = () => {
  return request({
    url: "/api/auth/phoneLogin",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      OS: "TEST",
    },
    data: {
      phone: "19921600619",
      verificationCode: "1234",
      thirdType: 1,
      sourceType: "1",
    },
  });
};

/**
 * 默认固定手机号获取短信验证码,仅测试环境使用
 */
export const loginSendMsg = () => {
  return request({
    url: "/api/auth/loginSendMsg",
    method: "POST",
    data: {
      phoneSet: ["19921600619"],
    },
  });
};

export function getUserInfo() {
  return request({ url: "/api/app/user/getUserInfo" });
}

// 查询接口，传jumpCode为单独查询，不传为全量查询,查询
export function getJumpConfig(jumpCode = "") {
  const params = jumpCode ? { jumpCode } : {};
  return request({ url: "/api/v5/jump/config/list", method: "get", params });
}
